var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28979 14.1318L12.279 3.14879C12.5475 2.72677 13.2008 2.917 13.2008 3.41722V11.2002C13.2008 11.2554 13.2456 11.3002 13.3008 11.3002H18.2405C18.645 11.3002 18.882 11.7555 18.6501 12.0869L11.7104 22.0007C11.4301 22.4012 10.8008 22.2029 10.8008 21.714V15.0002C10.8008 14.945 10.756 14.9002 10.7008 14.9002H5.71162C5.31707 14.9002 5.07797 14.4646 5.28979 14.1318Z",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoring);
export default __webpack_public_path__ + "static/media/monitoring.b46c9425e2193ab488da4a14fa53f1d9.svg";
export { ForwardRef as ReactComponent };